module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-2-108c8a2977615276d3b172c0f406fad0.jpg";